
import React, { useEffect, useRef } from 'react';
import Icon from '@ant-design/icons';
import classNames from 'classnames';
import RescueWidgetProcessor, { RescueWidgetState } from '@kemu-io/kemu-core/widgets/rescue/index.js';
import { WidgetPortContext } from '@kemu-io/kemu-core/types';
import { GetPortsInformationFunction, GateUI, GateUIProps } from '../index';
import GateIcon from '../../gateIcon/gateIcon';
import { ReactComponent as RescueWidgetIcon } from '../../../assets/img/gates/rescue-widget.svg';
import { PortLocation } from '../../../types/canvas_t';
import { buildOutputPortsDescription } from '../common';
import styles from './rescue.module.css';
import useReactiveWidgetState from '@hooks/useReactiveWidgetState';
import { DataType } from '@kemu-io/hs-types';


const compareState = (prevState: RescueWidgetState, nextState: RescueWidgetState): boolean => {
	const changed = prevState.$$lastEventType !== nextState.$$lastEventType;
	return changed;
};

const SequenceWidget = (props: GateUIProps): React.JSX.Element => {
	const { redrawPortsAndConnections, recipeId, thingRecipeId, info } = props;
	const [state] = useReactiveWidgetState<RescueWidgetState>(recipeId, thingRecipeId, info.id, compareState);
	const previouslyDrawnEventType = useRef<DataType | undefined>(undefined);

	/** Rebuild ports when the detected event type changes */
	useEffect(() => {
		const changed = previouslyDrawnEventType.current !== state.$$lastEventType;
		if(state.$$lastEventType && changed){
			previouslyDrawnEventType.current = state.$$lastEventType;
			redrawPortsAndConnections();
		}
	}, [state.$$lastEventType, redrawPortsAndConnections]);

	return (
		<div className={classNames(styles.GateBody, {
			[styles.WidgetDisabled]: props.info.disabled,
		})}>
			<Icon component={RescueWidgetIcon}/>
		</div>
	);
};

/** Icon to be added to the bar */
const GateBarIcon = (): React.JSX.Element => {
	return (
		<GateIcon icon={<Icon component={RescueWidgetIcon} />}/>
	);
};


const getPortsInformation: GetPortsInformationFunction = (state, widgetInfo) => {
	const portContext: WidgetPortContext = {
		recipePoolId: widgetInfo.recipePoolId,
		recipeType: widgetInfo.recipeType,
		thingRecipeId: widgetInfo.thingRecipeId,
		widgetId: widgetInfo.id,
	};
	const outputNames = RescueWidgetProcessor.getOutputNames(state, portContext);
	const inputNames = RescueWidgetProcessor.getInputNames(state, portContext);

	const outputs = buildOutputPortsDescription(outputNames, 0.14);
	const positions: Record<string, PortLocation> = {
		'event': 'Left',
	};

	return {
		inputs: inputNames.map(input => ({
			name: input.name,
			type: input.type,
			position: positions[input.name]
		})),

		outputs,
	};
};

export default {
	getPortsInformation,
	BarIcon: GateBarIcon,
	Element: SequenceWidget,
	hasTitle: false,
	getWidgetTitle: (intl) => intl.formatMessage({ id: 'LogicMapper.Widgets.Rescue.Title' }),
} as GateUI;
